import PrintCrossSell from './PrintCrossSell';

export default PrintCrossSell;
